(function () {
  'use strict';

  var modal = document.getElementById('tk-slp-spec-modal');
  var closeBtn = document.getElementById('tk-slp-spec-close');
  var submitBtn = document.getElementById('tk-slp-spec-submit');
  var emailInput = document.getElementById('tk-slp-spec-email');
  var nameInput = document.getElementById('tk-slp-spec-name');
  var companyInput = document.getElementById('tk-slp-spec-company');
  var optinInput = document.getElementById('tk-slp-spec-optin');
  var errorEl = document.getElementById('tk-slp-spec-error');
  var successEl = document.getElementById('tk-slp-spec-success');
  var productNameEl = document.getElementById('tk-slp-spec-product-name');
  var titleEl = document.getElementById('tk-slp-spec-modal-title');

  if (!modal) return;

  var currentProductPayload = null;
  var zapierWebhook = modal.dataset.zapierWebhook || '';

  function openModal(productId) {
    var payload = window.tkSlpProducts && window.tkSlpProducts[productId];
    if (!payload) {
      console.warn('tkSlp: no product data found for id', productId);
      return;
    }
    currentProductPayload = payload;
    if (titleEl) titleEl.textContent = 'Request specification sheet';
    if (productNameEl) productNameEl.textContent = payload.title;
    if (errorEl) errorEl.style.display = 'none';
    if (successEl) successEl.style.display = 'none';
    if (submitBtn) {
      submitBtn.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send me the specification sheet';
    }
    if (emailInput) emailInput.value = '';
    if (nameInput) nameInput.value = '';
    if (companyInput) companyInput.value = '';
    if (optinInput) optinInput.checked = false;
    modal.classList.add('tk-slp__spec-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      if (emailInput) emailInput.focus();
    }, 50);
  }

  function closeModal() {
    modal.classList.remove('tk-slp__spec-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    currentProductPayload = null;
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function sendToLitPDF(email, payload, onSuccess, onError) {
    var data = JSON.parse(JSON.stringify(payload));
    data.sendToEmail = email;
    data.selectedVariantId = payload.defaultVariantId;

    fetch('https://teknomek.co.uk/apps/theprintpdf1/api/send-pdf', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      }
    })
    .then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(text);
        });
      }
      return response.json();
    })
    .then(function (data) { onSuccess(data); })
    .catch(function (err) { onError(err); });
  }

  function sendToZapier(data) {
    if (!zapierWebhook || zapierWebhook === '' || zapierWebhook === '#') return;
    fetch(zapierWebhook, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-type': 'application/json; charset=UTF-8' }
    }).catch(function () {});
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var email = emailInput ? emailInput.value.trim() : '';
      var name = nameInput ? nameInput.value.trim() : '';
      var company = companyInput ? companyInput.value.trim() : '';

      if (!validateEmail(email)) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.style.display = 'block';
        }
        if (emailInput) emailInput.focus();
        return;
      }

      if (errorEl) errorEl.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = '... Sending ...';

      sendToLitPDF(email, currentProductPayload,
        function () {
          if (successEl) successEl.style.display = 'block';
          if (submitBtn) submitBtn.style.display = 'none';
          sendToZapier({
            full_name: name,
            email: email,
            company: company,
            product_name: currentProductPayload.title,
            product_handle: currentProductPayload.handle,
            marketing_opt_in: optinInput && optinInput.checked ? 'yes' : 'no',
            source: 'PPC landing page spec sheet',
            timestamp: new Date().toISOString()
          });
        },
        function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send me the specification sheet';
          }
          if (errorEl) {
            errorEl.textContent = 'Something went wrong. Please try again or call us on +44 (0)1603 788833.';
            errorEl.style.display = 'block';
          }
        }
      );
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('tk-slp__spec-modal--open')) {
      closeModal();
    }
  });

  window.tkSlpOpenSpecModal = openModal;
})();